module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-2500.43edeec7.svg";